const MOCK_PRODUCTS = [
  // ── Indian National Flags ──────────────────────────────────────────────────
  {
    id: 1,
    name: 'Indian National Flag – Standard',
    category: 'indian',
    categoryLabel: 'Indian Flags',
    price: 199,
    originalPrice: 249,
    image: '/Main photos/Indian flag.jpg',
    rating: 4.8,
    reviews: 124,
    sizes: ['2x3 ft', '3x4.5 ft', '4x6 ft', '6x9 ft'],
    description: 'Premium-quality Indian Tricolour flag made with durable polyester. Perfect for Independence Day, Republic Day and patriotic celebrations.',
    features: ['Weather Resistant', 'Fade Proof', 'Machine Stitched Hem'],
    inStock: true,
    badge: 'Best Seller'
  },
  {
    id: 2,
    name: 'Indian National Flag – Premium',
    category: 'indian',
    categoryLabel: 'Indian Flags',
    price: 299,
    originalPrice: 399,
    image: '/Main photos/Indian flag2.jpg',
    rating: 4.9,
    reviews: 87,
    sizes: ['3x4.5 ft', '4x6 ft', '6x9 ft'],
    description: 'Heavy-duty Tiranga flag with vibrant saffron, white and green colours. Reinforced edges for long-term outdoor use.',
    features: ['UV Resistant', 'Double Stitched', 'Brass Grommets'],
    inStock: true,
    badge: null
  },
  {
    id: 3,
    name: 'Indian Flag – Large Format',
    category: 'indian',
    categoryLabel: 'Indian Flags',
    price: 399,
    originalPrice: 499,
    image: '/Main photos/indian flags 4.jpeg',
    rating: 4.7,
    reviews: 56,
    sizes: ['4x6 ft', '6x9 ft', '8x12 ft'],
    description: 'Extra-large Indian flag ideal for building facades and major events. Extra-strong fabric with reinforced fly end.',
    features: ['Extra Large', 'Wind Resistant', 'Rope Included'],
    inStock: true,
    badge: 'Popular'
  },
  {
    id: 4,
    name: 'Indian Flag – XL Event',
    category: 'indian',
    categoryLabel: 'Indian Flags',
    price: 499,
    originalPrice: 599,
    image: '/Main photos/indian flags 5.jpeg',
    rating: 4.6,
    reviews: 42,
    sizes: ['6x9 ft', '8x12 ft', '10x15 ft'],
    description: 'XL-sized Tiranga for stages, pandals and large outdoor events. Rich colour print with anti-fray edges.',
    features: ['Stage Grade', 'Anti-Fray', 'Vibrant Print'],
    inStock: true,
    badge: null
  },
  {
    id: 5,
    name: 'Indian Flag – Deluxe Satin',
    category: 'indian',
    categoryLabel: 'Indian Flags',
    price: 599,
    originalPrice: 749,
    image: '/Main photos/Indianflag1.jpg',
    rating: 4.9,
    reviews: 33,
    sizes: ['2x3 ft', '3x4.5 ft', '4x6 ft'],
    description: 'Luxurious satin-finish Tricolour flag with glossy sheen. Ideal for indoor display and premium gift sets.',
    features: ['Satin Finish', 'Gift Ready', 'Pole Sleeve'],
    inStock: true,
    badge: 'Premium'
  },
  {
    id: 6,
    name: 'Indian Flag – Classic Cotton',
    category: 'indian',
    categoryLabel: 'Indian Flags',
    price: 249,
    originalPrice: 299,
    image: '/Main photos/Indianflag2.webp',
    rating: 4.5,
    reviews: 78,
    sizes: ['2x3 ft', '3x4.5 ft'],
    description: 'Traditional khadi-style cotton Indian flag. Lightweight and easy to carry for marches and school events.',
    features: ['Cotton Fabric', 'Lightweight', 'Eco Friendly'],
    inStock: true,
    badge: null
  },

  // ── BJP Flags ──────────────────────────────────────────────────────────────
  {
    id: 7,
    name: 'BJP Standard Flag',
    category: 'bjp',
    categoryLabel: 'BJP Flags',
    price: 149,
    originalPrice: 199,
    image: '/Main photos/BJP flag.jpg',
    rating: 4.7,
    reviews: 215,
    sizes: ['2x3 ft', '3x4.5 ft', '4x6 ft'],
    description: 'Official Bharatiya Janata Party flag with authentic saffron, white and green colours and Lotus symbol.',
    features: ['Official Design', 'Fade Proof', 'Quick Delivery'],
    inStock: true,
    badge: 'Best Seller'
  },
  {
    id: 8,
    name: 'BJP Campaign Flag',
    category: 'bjp',
    categoryLabel: 'BJP Flags',
    price: 199,
    originalPrice: 249,
    image: '/Main photos/bjp flags 2.jpeg',
    rating: 4.6,
    reviews: 93,
    sizes: ['3x4.5 ft', '4x6 ft', '6x9 ft'],
    description: 'Large BJP campaign flag for rallies and political gatherings. Bright saffron with crisp Lotus print.',
    features: ['Rally Grade', 'Bulk Discounts', 'Fast Delivery'],
    inStock: true,
    badge: null
  },
  {
    id: 9,
    name: 'BJP Rally Flag',
    category: 'bjp',
    categoryLabel: 'BJP Flags',
    price: 249,
    originalPrice: 299,
    image: '/Main photos/bjp flags 4.jpeg',
    rating: 4.8,
    reviews: 67,
    sizes: ['4x6 ft', '6x9 ft'],
    description: 'Heavy-duty BJP rally flag designed for outdoor events. UV-resistant inks keep the Lotus vibrant.',
    features: ['UV Resistant', 'Double Stitched', 'All Weather'],
    inStock: true,
    badge: 'Popular'
  },
  {
    id: 10,
    name: 'BJP Large Event Flag',
    category: 'bjp',
    categoryLabel: 'BJP Flags',
    price: 299,
    originalPrice: 399,
    image: '/Main photos/bjp flags 5.jpeg',
    rating: 4.5,
    reviews: 44,
    sizes: ['6x9 ft', '8x12 ft'],
    description: 'Extra-large BJP flag for stage backdrops and mega rallies. Strong grommets for pole mounting.',
    features: ['Stage Backdrop', 'Brass Grommets', 'Wind Proof'],
    inStock: true,
    badge: null
  },

  // ── Congress Flags ─────────────────────────────────────────────────────────
  {
    id: 11,
    name: 'Congress Standard Flag',
    category: 'congress',
    categoryLabel: 'Congress Flags',
    price: 149,
    originalPrice: 199,
    image: '/Main photos/congress flags.jpeg',
    rating: 4.7,
    reviews: 178,
    sizes: ['2x3 ft', '3x4.5 ft', '4x6 ft'],
    description: 'Authentic Indian National Congress flag with traditional tricolour design and Congress Hand symbol.',
    features: ['Official Design', 'Vibrant Colours', 'Quick Delivery'],
    inStock: true,
    badge: 'Best Seller'
  },
  {
    id: 12,
    name: 'Congress Campaign Flag',
    category: 'congress',
    categoryLabel: 'Congress Flags',
    price: 199,
    originalPrice: 249,
    image: '/Main photos/congress flags 2.jpeg',
    rating: 4.6,
    reviews: 82,
    sizes: ['3x4.5 ft', '4x6 ft', '6x9 ft'],
    description: 'Congress campaign flag for election rallies. Bold colours with clear symbol for long-distance visibility.',
    features: ['High Visibility', 'Rally Grade', 'Bulk Orders'],
    inStock: true,
    badge: null
  },
  {
    id: 13,
    name: 'Congress Premium Flag',
    category: 'congress',
    categoryLabel: 'Congress Flags',
    price: 249,
    originalPrice: 299,
    image: '/Main photos/congress flags 5.jpeg',
    rating: 4.8,
    reviews: 51,
    sizes: ['4x6 ft', '6x9 ft'],
    description: 'Premium Congress flag with reinforced edges and brass grommets. Ideal for permanent outdoor installation.',
    features: ['Brass Grommets', 'Reinforced Edges', 'Outdoor Grade'],
    inStock: true,
    badge: 'Popular'
  },
  {
    id: 14,
    name: 'Congress Classic Flag',
    category: 'congress',
    categoryLabel: 'Congress Flags',
    price: 179,
    originalPrice: 219,
    image: '/Main photos/congress flags1.png',
    rating: 4.5,
    reviews: 39,
    sizes: ['2x3 ft', '3x4.5 ft'],
    description: 'Classic lightweight Congress flag for hand-held use at events and marches.',
    features: ['Lightweight', 'Hand-Held', 'Event Ready'],
    inStock: true,
    badge: null
  },

  // ── Ganesh Chaturthi Flags ─────────────────────────────────────────────────
  {
    id: 15,
    name: 'Ganesh Chaturthi Flag',
    category: 'ganesh',
    categoryLabel: 'Ganesh Festival Flags',
    price: 179,
    originalPrice: 229,
    image: '/Main photos/ganesh 1.jpeg',
    rating: 4.9,
    reviews: 143,
    sizes: ['2x3 ft', '3x4.5 ft', '4x6 ft'],
    description: 'Beautiful Lord Ganesh flag for Ganesh Chaturthi celebrations. Rich orange and gold colours with detailed Ganesh artwork.',
    features: ['Festival Special', 'Vibrant Colours', 'Divine Design'],
    inStock: true,
    badge: 'Best Seller'
  },
  {
    id: 16,
    name: 'Ganesh Premium Flag',
    category: 'ganesh',
    categoryLabel: 'Ganesh Festival Flags',
    price: 249,
    originalPrice: 329,
    image: '/Main photos/ganesh2.jpeg',
    rating: 4.8,
    reviews: 96,
    sizes: ['3x4.5 ft', '4x6 ft'],
    description: 'Premium Ganesh flag with intricate golden border design. Perfect for mandap decoration and home puja room.',
    features: ['Golden Border', 'Mandap Grade', 'Puja Ready'],
    inStock: true,
    badge: 'Premium'
  },
  {
    id: 17,
    name: 'Ganesh Classic Flag',
    category: 'ganesh',
    categoryLabel: 'Ganesh Festival Flags',
    price: 199,
    originalPrice: 249,
    image: '/Main photos/ganesh3.jpeg',
    rating: 4.7,
    reviews: 68,
    sizes: ['2x3 ft', '3x4.5 ft', '4x6 ft'],
    description: 'Classic Ganesh Chaturthi flag in traditional saffron with Om symbol and Ganesh idol print.',
    features: ['Traditional Design', 'Saffron Fabric', 'Om Symbol'],
    inStock: true,
    badge: null
  },
  {
    id: 18,
    name: 'Ganesh Festival Special Flag',
    category: 'ganesh',
    categoryLabel: 'Ganesh Festival Flags',
    price: 299,
    originalPrice: 379,
    image: '/Main photos/ganesh5.jpg',
    rating: 4.9,
    reviews: 54,
    sizes: ['4x6 ft', '6x9 ft'],
    description: 'Extra-large Ganesh festival flag for procession floats and community pandals. Eye-catching full-colour print.',
    features: ['Procession Grade', 'Full Colour', 'Extra Large'],
    inStock: true,
    badge: 'Popular'
  },
  {
    id: 19,
    name: 'Ganesh Devotional Flag',
    category: 'ganesh',
    categoryLabel: 'Ganesh Festival Flags',
    price: 219,
    originalPrice: 269,
    image: '/Main photos/Ganesh1.jpeg',
    rating: 4.6,
    reviews: 47,
    sizes: ['2x3 ft', '3x4.5 ft'],
    description: 'Devotional Ganesh flag with Sanskrit shloka border. Ideal for home and shop decoration during Ganesh Utsav.',
    features: ['Sanskrit Shloka', 'Home Décor', 'Shop Ready'],
    inStock: true,
    badge: null
  },
  {
    id: 20,
    name: 'Ganesh Decorative Banner',
    category: 'ganesh',
    categoryLabel: 'Ganesh Festival Flags',
    price: 189,
    originalPrice: 239,
    image: '/Main photos/ganesh images1.jpeg',
    rating: 4.5,
    reviews: 31,
    sizes: ['2x3 ft', '3x4.5 ft'],
    description: 'Decorative Ganesh banner flag with colourful floral border. Lightweight and easy to hang.',
    features: ['Floral Border', 'Lightweight', 'Easy Hang'],
    inStock: true,
    badge: null
  },

  // ── Hanuman Flags ──────────────────────────────────────────────────────────
  {
    id: 21,
    name: 'Hanuman Devotional Flag',
    category: 'hanuman',
    categoryLabel: 'Hanuman Flags',
    price: 179,
    originalPrice: 229,
    image: '/Main photos/Hanuman flag1.jpeg',
    rating: 4.9,
    reviews: 189,
    sizes: ['2x3 ft', '3x4.5 ft', '4x6 ft'],
    description: 'Sacred Hanuman flag in bright saffron with Jai Bajrang Bali text. Ideal for temples and home puja.',
    features: ['Sacred Design', 'Temple Quality', 'Saffron Fabric'],
    inStock: true,
    badge: 'Best Seller'
  },
  {
    id: 22,
    name: 'Hanuman Sacred Flag',
    category: 'hanuman',
    categoryLabel: 'Hanuman Flags',
    price: 229,
    originalPrice: 279,
    image: '/Main photos/Hanuman flag2.jpeg',
    rating: 4.8,
    reviews: 112,
    sizes: ['3x4.5 ft', '4x6 ft'],
    description: 'Premium Hanuman flag with detailed warrior pose artwork. Blessed designs for religious ceremonies.',
    features: ['Warrior Design', 'Blessed Art', 'Premium Fabric'],
    inStock: true,
    badge: 'Popular'
  },
  {
    id: 23,
    name: 'Hanuman Temple Flag',
    category: 'hanuman',
    categoryLabel: 'Hanuman Flags',
    price: 299,
    originalPrice: 379,
    image: '/Main photos/Hanuman flag3.webp',
    rating: 4.7,
    reviews: 74,
    sizes: ['4x6 ft', '6x9 ft'],
    description: 'Large Hanuman flag for temple entrances and religious processions. Extra durable for outdoor installation.',
    features: ['Temple Entrance', 'Outdoor Grade', 'Large Format'],
    inStock: true,
    badge: null
  },
  {
    id: 24,
    name: 'Hanuman Premium Flag',
    category: 'hanuman',
    categoryLabel: 'Hanuman Flags',
    price: 249,
    originalPrice: 299,
    image: '/Main photos/Hanumanflag2.webp',
    rating: 4.8,
    reviews: 58,
    sizes: ['2x3 ft', '3x4.5 ft', '4x6 ft'],
    description: 'Premium Hanuman flag with gold border and embossed-look print. Perfect for home and vehicle mounting.',
    features: ['Gold Border', 'Embossed Print', 'Vehicle Mount'],
    inStock: true,
    badge: 'Premium'
  },
  {
    id: 25,
    name: 'Hanuman Classic Flag',
    category: 'hanuman',
    categoryLabel: 'Hanuman Flags',
    price: 199,
    originalPrice: 249,
    image: '/Main photos/Hanmuna flag3.webp',
    rating: 4.6,
    reviews: 43,
    sizes: ['2x3 ft', '3x4.5 ft'],
    description: 'Classic Hanuman flag in traditional saffron. Lightweight for handheld use in Hanuman Jayanti processions.',
    features: ['Classic Style', 'Handheld', 'Procession Ready'],
    inStock: true,
    badge: null
  },

  // ── TRS / BRS Flags ────────────────────────────────────────────────────────
  {
    id: 26,
    name: 'TRS Standard Flag',
    category: 'trs',
    categoryLabel: 'TRS / BRS Flags',
    price: 149,
    originalPrice: 199,
    image: '/Main photos/trs flags 1.jpeg',
    rating: 4.6,
    reviews: 91,
    sizes: ['2x3 ft', '3x4.5 ft', '4x6 ft'],
    description: 'Telangana Rashtra Samithi flag with official pink and white design. Ready for Telangana state political events.',
    features: ['Official Design', 'State Pride', 'Vibrant Pink'],
    inStock: true,
    badge: 'Best Seller'
  },
  {
    id: 27,
    name: 'TRS Campaign Flag',
    category: 'trs',
    categoryLabel: 'TRS / BRS Flags',
    price: 199,
    originalPrice: 249,
    image: '/Main photos/trs flags 3.jpeg',
    rating: 4.5,
    reviews: 48,
    sizes: ['3x4.5 ft', '4x6 ft', '6x9 ft'],
    description: 'Large TRS campaign flag for rallies and political gatherings. Bold print with high outdoor visibility.',
    features: ['Rally Grade', 'High Visibility', 'Bulk Orders'],
    inStock: true,
    badge: null
  },

  // ── TDP Flags ──────────────────────────────────────────────────────────────
  {
    id: 28,
    name: 'TDP Standard Flag',
    category: 'tdp',
    categoryLabel: 'TDP Flags',
    price: 149,
    originalPrice: 199,
    image: '/Main photos/tdp flags 1.jpeg',
    rating: 4.7,
    reviews: 104,
    sizes: ['2x3 ft', '3x4.5 ft', '4x6 ft'],
    description: 'Telugu Desam Party flag with vibrant yellow and Cycling Wheel symbol. Perfect for TDP events and campaigns.',
    features: ['Official Design', 'Vibrant Yellow', 'Cycle Symbol'],
    inStock: true,
    badge: 'Best Seller'
  },
  {
    id: 29,
    name: 'TDP Classic Flag',
    category: 'tdp',
    categoryLabel: 'TDP Flags',
    price: 179,
    originalPrice: 219,
    image: '/Main photos/tdp flags 2.png',
    rating: 4.5,
    reviews: 61,
    sizes: ['2x3 ft', '3x4.5 ft'],
    description: 'Classic TDP flag in bold yellow with sharp print. Great for indoor meetings and hand-held use at rallies.',
    features: ['Bold Yellow', 'Sharp Print', 'Hand-Held'],
    inStock: true,
    badge: null
  },
  {
    id: 30,
    name: 'TDP Campaign Flag',
    category: 'tdp',
    categoryLabel: 'TDP Flags',
    price: 199,
    originalPrice: 249,
    image: '/Main photos/tdp flags 5.jpeg',
    rating: 4.6,
    reviews: 53,
    sizes: ['3x4.5 ft', '4x6 ft', '6x9 ft'],
    description: 'Large TDP campaign flag with reinforced hems for outdoor campaign use. Crisp yellow and white contrast.',
    features: ['Reinforced Hem', 'Outdoor Grade', 'Campaign Ready'],
    inStock: true,
    badge: 'Popular'
  },

  // ── Buntings & Thorans (Our Specials) ─────────────────────────────────────
  {
    id: 32, name: 'Kesari Saffron Thoran',
    category: 'buntings', categoryLabel: 'Buntings & Thorans', image: null,
    thoranColors: ['#FF9933','#FF9933','#FF9933','#FF9933','#FF9933'],
    bgColor: '#FFF3E0', rating: 4.9, reviews: 210,
    sizes: ['20 Meters', '500 Meters', '1000 Meters', '2000 Meters'],
    description: 'Premium Kesari (saffron) cloth bunting thoran for religious events, rally processions, pandals and road-side decoration. Reusable & washable cotton.',
    features: ['Cotton Cloth', 'Reusable & Washable', 'Bulk Orders Available'],
    inStock: true, badge: 'Our Special'
  },
  {
    id: 33, name: 'Tricolor Thoran (National)',
    category: 'buntings', categoryLabel: 'Buntings & Thorans', image: null,
    thoranColors: ['#FF9933','#FFFFFF','#138808','#FF9933','#FFFFFF','#138808'],
    bgColor: '#F0F8FF', rating: 4.8, reviews: 175,
    sizes: ['20 Meters', '500 Meters', '1000 Meters', '2000 Meters'],
    description: 'Indian Tricolour bunting thoran in saffron, white and green. Ideal for Independence Day, Republic Day and national events.',
    features: ['National Colours', 'Cotton Fabric', 'Indoor & Outdoor'],
    inStock: true, badge: 'Our Special'
  },
  {
    id: 34, name: 'BJP Orange Thoran',
    category: 'buntings', categoryLabel: 'Buntings & Thorans', image: null,
    thoranColors: ['#FF6600','#FF8C00','#FF6600','#FF8C00','#FF6600'],
    bgColor: '#FFF5EE', rating: 4.7, reviews: 143,
    sizes: ['20 Meters', '500 Meters', '1000 Meters'],
    description: 'Vibrant BJP orange cloth bunting thoran for political rallies, election campaigns and party events.',
    features: ['Party Events', 'Bulk Wholesale', 'Washable'],
    inStock: true, badge: 'Our Special'
  },
  {
    id: 35, name: 'Jai Bhim Blue & Yellow Thoran',
    category: 'buntings', categoryLabel: 'Buntings & Thorans', image: null,
    thoranColors: ['#1565C0','#FDD835','#1565C0','#FDD835','#1565C0','#FDD835'],
    bgColor: '#E3F2FD', rating: 4.8, reviews: 162,
    sizes: ['20 Meters', '500 Meters', '1000 Meters', '2000 Meters'],
    description: 'Jai Bhim blue and yellow thoran for Ambedkar Jayanti, social events and community programme decoration.',
    features: ['Blue & Yellow', 'Cotton Cloth', 'Bulk Orders'],
    inStock: true, badge: 'Our Special'
  },
  {
    id: 36, name: 'Karnataka Red & Yellow Thoran',
    category: 'buntings', categoryLabel: 'Buntings & Thorans', image: null,
    thoranColors: ['#CC0000','#FFD700','#CC0000','#FFD700','#CC0000','#FFD700'],
    bgColor: '#FFF8E1', rating: 4.9, reviews: 134,
    sizes: ['20 Meters (1 Set)', '50 Meters (2 Pack)', '500 Meters Bulk'],
    description: 'Karnataka Rajyotsava special thoran in red and yellow. Reusable, washable and ready to use for indoor and outdoor events.',
    features: ['Red & Yellow', 'Reusable', 'Ready To Use'],
    inStock: true, badge: 'Our Special'
  },
  {
    id: 37, name: 'Festive Green Thoran',
    category: 'buntings', categoryLabel: 'Buntings & Thorans', image: null,
    thoranColors: ['#28A745','#20C997','#28A745','#20C997','#28A745'],
    bgColor: '#F0FFF4', rating: 4.7, reviews: 98,
    sizes: ['20 Meters', '500 Meters', '1000 Meters'],
    description: 'Festive green cloth bunting thoran for Eid, dargah decorations, Congress events and general festive occasions.',
    features: ['Festive Green', 'Bright Colour', 'Multi-Purpose'],
    inStock: true, badge: 'Our Special'
  },
  {
    id: 38, name: 'TDP Yellow Thoran',
    category: 'buntings', categoryLabel: 'Buntings & Thorans', image: null,
    thoranColors: ['#FDD835','#FFB300','#FDD835','#FFB300','#FDD835'],
    bgColor: '#FFFDE7', rating: 4.6, reviews: 88,
    sizes: ['20 Meters', '500 Meters', '1000 Meters'],
    description: 'Vibrant yellow TDP bunting thoran for Telugu Desam Party events and campaigns.',
    features: ['Vibrant Yellow', 'Cotton Cloth', 'Campaign Ready'],
    inStock: true, badge: 'Our Special'
  },
  {
    id: 39, name: 'TRS Pink & White Thoran',
    category: 'buntings', categoryLabel: 'Buntings & Thorans', image: null,
    thoranColors: ['#FF1493','#FFFFFF','#FF1493','#FFFFFF','#FF1493','#FFFFFF'],
    bgColor: '#FFF0F5', rating: 4.7, reviews: 76,
    sizes: ['20 Meters', '500 Meters', '1000 Meters'],
    description: 'TRS pink and white bunting thoran for Telangana state party events, rallies and processions.',
    features: ['Pink & White', 'State Party', 'Reusable'],
    inStock: true, badge: 'Our Special'
  },
  {
    id: 40, name: 'Multicolor Rainbow Thoran',
    category: 'buntings', categoryLabel: 'Buntings & Thorans', image: null,
    thoranColors: ['#FF4444','#FF9933','#FDD835','#28A745','#1565C0','#9B59B6'],
    bgColor: '#F8F0FF', rating: 4.9, reviews: 201,
    sizes: ['20 Meters', '500 Meters', '1000 Meters'],
    description: 'Vibrant multicolor rainbow thoran for all occasions — festivals, weddings, cultural events and pandals. Every colour in one string!',
    features: ['All Colours', 'Festival Ready', 'Eye Catching'],
    inStock: true, badge: 'Our Special'
  },
  {
    id: 42, name: 'Large Scale Event Thoran – Roundabout Special',
    category: 'buntings', categoryLabel: 'Buntings & Thorans',
    image: '/Main photos/thoran-event.jpg',
    thoranColors: null,
    bgColor: null,
    rating: 5.0, reviews: 312,
    sizes: ['500 Meters', '1000 Meters', '2000 Meters', 'Custom Length'],
    description: 'Massive saffron thoran supply for large-scale city events, political rallies and roundabout decorations. We have supplied bulk thorans for events like the one pictured — covering entire intersections.',
    features: ['Large Scale Supply', 'Bulk Wholesale', 'Custom Orders'],
    inStock: true, badge: 'Our Special'
  },
  {
    id: 41, name: 'Red Thoran (Congress / Special)',
    category: 'buntings', categoryLabel: 'Buntings & Thorans', image: null,
    thoranColors: ['#CC0000','#E53935','#CC0000','#E53935','#CC0000'],
    bgColor: '#FFF5F5', rating: 4.6, reviews: 67,
    sizes: ['20 Meters', '500 Meters', '1000 Meters'],
    description: 'Bold red bunting thoran for Congress party events, communist processions, trade union rallies and general festive use.',
    features: ['Bold Red', 'Cotton Cloth', 'All Events'],
    inStock: true, badge: 'Our Special'
  },

  // ── Sri Ramanavami Flags ───────────────────────────────────────────────────
  {
    id: 31,
    name: 'Sri Ramanavami Celebration Flag',
    category: 'ramanavami',
    categoryLabel: 'Sri Ramanavami Flags',
    price: 199,
    originalPrice: 249,
    image: '/Main photos/Srirama navami flags.jpeg',
    rating: 4.9,
    reviews: 137,
    sizes: ['2x3 ft', '3x4.5 ft', '4x6 ft'],
    description: 'Special Sri Ramanavami flag with Lord Rama artwork in golden hues. Ideal for temple decoration and procession.',
    features: ['Festive Design', 'Golden Hues', 'Procession Ready'],
    inStock: true,
    badge: 'Festival Special'
  }
];

// ── Helper functions ───────────────────────────────────────────────────────────

export const getProductsByCategory = (category) => {
  if (!category) return MOCK_PRODUCTS;
  return MOCK_PRODUCTS.filter(p => p.category === category.toLowerCase());
};

export const getProductById = (id) => {
  return MOCK_PRODUCTS.find(p => p.id === parseInt(id));
};

export const getFeaturedProducts = () => {
  return MOCK_PRODUCTS.filter(p => p.badge === 'Best Seller').slice(0, 6);
};

export const getLatestProducts = () => {
  return MOCK_PRODUCTS.slice(-8);
};

export const getBestRatedProducts = () => {
  return [...MOCK_PRODUCTS].sort((a, b) => b.rating - a.rating).slice(0, 6);
};

export const getAllCategories = () => {
  const cats = [...new Set(MOCK_PRODUCTS.map(p => p.category))];
  return cats.map(c => ({
    id: c,
    label: MOCK_PRODUCTS.find(p => p.category === c).categoryLabel,
    count: MOCK_PRODUCTS.filter(p => p.category === c).length
  }));
};

export default MOCK_PRODUCTS;
